<template>
  <div class="mb-10">
    <h2 class="company-product--heading">
      {{ products.title }}
    </h2>
    <div class="campany-nav mt-10">
      <div class="campany-nav--buttons">
        <button
          @click="$router.push({ name: btn.path })"
          class="campany-nav--btn px-5"
          v-for="btn in products.buttons"
          :key="btn.id"
        >
          <div>
            <i :class="btn.class"></i>
          </div>
          <div class="campany-nav--btn--title ml-md-2">{{ btn.title }}</div>
          <div class="campany-nav--btn--arrow">
            <i class="fas fa-arrow-right fa-lg"></i>
          </div>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    products: {
      type: Object,
      require: true
    }
  },
  data () {
    return {}
  }
}
</script>
